import React, { useEffect, useState } from 'react'
import { Container, Col, Row } from 'react-bootstrap'
import axios from 'axios'
import SpinnerComponents from '../../components/Spinner/SpinnerComponents'
import PaginationComponent from '../../components/Pagination/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { editPost, fetchShows } from '../../redux/actions/showsactions'
import { Link } from 'react-router-dom'
import './show.css'

const Show = () => {
  const [category, setCategory] = useState([])
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  let totalItems;
  let currentItems;
  let totalPages;
  const itemsPerPage = 12;

  const shows = useSelector(state => state.shows)
  const dispatch = useDispatch()

  useEffect(() => {
    const myfetch = async () => {
      try {
        const res = await axios.get('https://nastaanaisie.pythonanywhere.com/api/categories/')
        setCategory(res.data)
      } catch (error) {
        console.error('Error fetching categories:', error)
      }
    }

    myfetch()
    dispatch(fetchShows())
  }, [dispatch])

  useEffect(() => {
    if (shows && shows.shows && shows.shows.results) {
      setData(shows.shows.results)
      setLoading(false)
    } else if (shows && shows.shows && Array.isArray(shows.shows)) {
      setData(shows.shows)
      setLoading(false)
    }
  }, [shows])

  // Calculate pagination
  if (data && data.length > 0) {
    totalItems = data.length;
    totalPages = Math.ceil(totalItems / itemsPerPage);
    let indexOfLastItem = currentPage * itemsPerPage;
    let indexOfFirstItem = indexOfLastItem - itemsPerPage;
    currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const catFilter = (name) => {
    let items = data.filter((cat) => cat.name === name)
    if (items.length > 0) {
      dispatch(editPost(items))
    } else {
      dispatch(fetchShows())
    }
  }

  return (
    <div className="shows-page">
      <Container>
        {/* Page Header */}
        <div className="shows-header">
          <h6 className="shows-subtitle">Browse Our Collection</h6>
          <h1 className="shows-title">TV Shows</h1>
          <p className="shows-description">
            Discover the latest TV shows and series
          </p>
        </div>

        {/* Category Filter (Optional) */}
        {category && category.length > 0 && (
          <div className="shows-categories">
            <button 
              className="category-btn active"
              onClick={() => dispatch(fetchShows())}
            >
              All Shows
            </button>
            {category.map(item => (
              <button
                key={item.id}
                className="category-btn"
                onClick={() => catFilter(item.name)}
              >
                {item.name}
              </button>
            ))}
          </div>
        )}

        {/* Loading State */}
        {loading && (
          <div className="shows-loading">
            <SpinnerComponents />
          </div>
        )}

        {/* Shows Grid */}
        {!loading && data && data.length > 0 ? (
          <>
            <Row className="shows-grid">
              {currentItems && currentItems.map(item => (
                <Col xs={6} sm={4} md={3} lg={2} xl={2} key={item.id} className="show-col">
                  <Link to={`/shows/${item.id}`} className="show-card-link">
                    <div className="show-card">
                      <div className="show-image-wrapper">
                        <img 
                          src={item.Image} 
                          className="show-image" 
                          alt={item.title}
                          loading="lazy"
                        />
                        <div className="show-overlay">
                          <div className="play-icon-show">▶</div>
                        </div>
                      </div>
                      <h6 className="show-title-text">{item.title}</h6>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="shows-pagination">
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </>
        ) : !loading && (
          <div className="shows-empty">
            <p>No shows available at the moment.</p>
          </div>
        )}
      </Container>
    </div>
  )
}

export default Show
